<template>
  <svg
    :width="width"
    :height="height"
    class="icon-weight"
    viewBox="0 0 25 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 15.318V0.275999H2.668V7.107H2.737L8.096 0.275999H11.063L6.44 6.141L11.845 15.318H8.901L4.83 8.234L2.668 10.925V15.318H0ZM19.4641 15.594C18.4521 15.594 17.5091 15.4253 16.6351 15.088C15.7764 14.7507 15.0251 14.2523 14.3811 13.593C13.7524 12.9337 13.2618 12.121 12.9091 11.155C12.5564 10.189 12.3801 9.085 12.3801 7.843C12.3801 6.61633 12.5641 5.52 12.9321 4.554C13.3001 3.57267 13.7984 2.74467 14.4271 2.07C15.0711 1.39533 15.8224 0.88167 16.6811 0.529C17.5551 0.176333 18.4904 0 19.4871 0C20.5604 0 21.4651 0.199333 22.2011 0.598C22.9524 0.98133 23.5658 1.41833 24.0411 1.909L22.6151 3.634C22.2318 3.266 21.8024 2.95933 21.3271 2.714C20.8671 2.45333 20.2844 2.323 19.5791 2.323C18.9044 2.323 18.2911 2.45333 17.7391 2.714C17.2024 2.95933 16.7348 3.31967 16.3361 3.795C15.9528 4.255 15.6538 4.82233 15.4391 5.497C15.2244 6.17167 15.1171 6.93067 15.1171 7.774C15.1171 9.4913 15.5004 10.8407 16.2671 11.822C17.0491 12.788 18.1991 13.271 19.7171 13.271C20.1464 13.271 20.5528 13.2173 20.9361 13.11C21.3194 12.9873 21.6338 12.8187 21.8791 12.604V9.361H19.0271V7.176H24.2711V13.8C23.7651 14.306 23.0904 14.7353 22.2471 15.088C21.4191 15.4253 20.4914 15.594 19.4641 15.594Z"
      fill="#495057"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconWeight',
  props: {
    width: {
      type: Number,
      default: 20,
    },
    height: {
      type: Number,
      default: 15,
    },
  },
};
</script>

<style scoped>
</style>